const ct_burger = document.querySelector('.ct-burger');
const ct_close = document.querySelector('.ct-side-close');
const ct_main = document.querySelector('.ct-side-menu');
const open_menu=document.querySelector('.open-menu')

const bottom_btn=document.querySelector('.ct-burger_bottom')
const bottom_menu_open =document.querySelector('.ct-side-menu-bottom')
const bottom_menu_close =document.querySelector('.ct-side-close-botom')
const open_menu_bottom=document.querySelector('.open-menu-bottom')

ct_burger.addEventListener('click', function(){
    ct_main.classList.add('ct-side-menu-open')
    open_menu.classList.add('site-open-menu')    
})

ct_close.addEventListener('click', function(){
    ct_main.classList.remove('ct-side-menu-open')
    open_menu.classList.remove('site-open-menu')
       
})

bottom_btn.addEventListener('click', function(){
  bottom_menu_open.classList.toggle('ct-side-menu-bottom-open')
  open_menu_bottom.classList.toggle('site-open-menu')
})
bottom_menu_close.addEventListener('click', function(){
  bottom_menu_open.classList.remove('ct-side-menu-bottom-open')
  open_menu_bottom.classList.remove('site-open-menu')
})

/* js for variant change */
function variant_data_change(image_src,index){
  document.getElementById('dev_v_img-'+index).innerHTML = "<img src='"+image_src+"'>";
}


$(document).ready(function(){
  $('.chack_no').click(function(){
      $('.chack_display').removeClass('ct-form-active');       
  });
  $('.chack_yes').click(function(){
      $('.chack_display').addClass('ct-form-active');       
  });
});





document.addEventListener("DOMContentLoaded", function () {
  const megaMenus = document.querySelectorAll('.header__inline-menu details.mega-menu');
  megaMenus.forEach(function(menu) {
    menu.addEventListener('mouseenter', function() {
      menu.setAttribute('open', true);
    });
    menu.addEventListener('mouseleave', function() {
      menu.removeAttribute('open');
    });
  });

  const searchDetails = document.querySelector('.header__search details');
  function handleDetailsState() {
    if (!searchDetails) return;
  
    if (window.innerWidth > 1010) {
      searchDetails.setAttribute('open', 'true');
    } else {
      searchDetails.removeAttribute('open');
    }
  }
  handleDetailsState();
  window.addEventListener('resize', handleDetailsState);
});
